// TODO: DEPRACETED: Divider can be removed
export const Divider = () => {
  return <hr className="my-12 h-0.5 border-t-0 bg-neutral-100 opacity-100" />;
};
